import React, { lazy } from 'react';
import { CheckCircleIcon, TimerIcon, ShieldCheckIcon, UnlockIcon, DownloadIcon } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
import { ShimmerButton } from './ShimmerButton';
import { useCountdown } from '../hooks/useCountdown';
interface OfferCardProps {
  onCtaClick: () => void;
}
export function OfferCard({
  onCtaClick
}: OfferCardProps) {
  const {
    formatted: formatTime
  } = useCountdown();
  const benefits = [{
    text: 'Método Silencio en 7 minutos',
    value: '$24.990'
  }, {
    text: 'Bonus 1: Checklist de Salud Mental Canina',
    value: '$14.990'
  }, {
    text: 'Bonus 2: Guía de Emergencia Anti-Ladridos',
    value: '$9.990'
  }, {
    text: 'Bonus 3: Matriz de Juegos de Olfato en Casa',
    value: '$7.990'
  }, {
    text: 'Bonus 4: Paquete de Actualizaciones de por vida',
    value: '$4.990'
  }];
  return <section className="py-24 px-5 pt-[15px] pb-[15px] space-y-[15px]" data-id="element-145">
      <FadeInUp className="max-w-3xl mx-auto bg-zen-beige rounded-3xl shadow-xl overflow-hidden relative border border-black/5" data-id="element-146">
        <div className="p-8 md:p-12 text-center pt-[30px] pb-[30px] space-y-[20px]" data-id="element-147">
          <div className="mb-8" data-id="element-148">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-slate-dark mb-3 leading-tight" data-id="element-149">
              Presentamos: El Protocolo Maestro de Silencio
            </h2>
            <p className="text-lg text-slate-dark/70 font-medium pt-[10px] pb-[10px]" data-id="element-150">
              Todo lo que necesitas para recuperar la paz de tu hogar, desde hoy
              mismo.
            </p>

            <img src="https://cdn.magicpatterns.com/uploads/5ic8Sn8NZXtkyB1DMJyWGM/metodosilecio2_v2.webp" alt="Método Silencio - Cero Ladridos y Destrozos" className="w-full h-auto rounded-2xl" loading="lazy" width={733} height={733} decoding="async" data-id="element-151" />
          </div>

          <div className="space-y-4 mb-10 text-left bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-black/5" data-id="element-152">
            {benefits.map((benefit, index) => <div key={index} className="flex items-center justify-between pb-4 border-b border-gray-100 last:border-0 last:pb-0 gap-4" data-id="element-153">
                <div className="flex items-start gap-3" data-id="element-154">
                  <CheckCircleIcon className="w-6 h-6 text-pistachio shrink-0 mt-0.5" data-id="element-155" />
                  <span className="text-slate-dark font-medium md:text-lg" data-id="element-156">
                    {benefit.text}
                  </span>
                </div>
                <span className="text-slate-dark/40 line-through font-bold shrink-0 md:text-lg" data-id="element-157">
                  {benefit.value}
                </span>
              </div>)}

            <div className="flex flex-col sm:flex-row justify-between items-center pt-6 mt-2 border-t-2 border-dashed border-gray-200 gap-4" data-id="element-158">
              <span className="text-slate-dark/50 text-xl font-bold line-through" data-id="element-159">
                VALOR TOTAL: $62.950
              </span>
              <span className="md:text-3xl font-bold text-green-600 bg-green-50 px-4 py-2 rounded-xl border border-green-100 text-[16px]" data-id="element-160">
                SOLO POR HOY: $4.990
              </span>
            </div>
          </div>

          <div className="mb-8 space-y-6" data-id="element-161">
            <p className="text-slate-dark/80 max-w-2xl mx-auto text-[20px] font-[700]" data-id="element-162">
              Este precio desaparece cuando el temporizador llega a cero.
            </p>

            <p className="text-slate-dark/80 font-medium max-w-2xl mx-auto" data-id="element-163">
              Mi misión es que ningún dueño sufra por los ladridos, destrozos o
              ansiedad de su perro. Sin excepciones.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto" data-id="element-164">
              <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm" data-id="element-165">
                <span className="block text-xs font-bold text-slate-dark/50 uppercase tracking-wider mb-1" data-id="element-166">
                  Precio Normal
                </span>
                <span className="block text-xl font-bold line-through text-[#767676]" data-id="element-167">
                  $62.950
                </span>
              </div>
              <div className="bg-pistachio/20 p-4 rounded-xl border border-pistachio shadow-sm" data-id="element-168">
                <span className="block text-xs font-bold text-green-800 uppercase tracking-wider mb-1" data-id="element-169">
                  Solo Por Hoy
                </span>
                <span className="block text-2xl font-bold text-green-700" data-id="element-170">
                  $4.990
                </span>
              </div>

              <p className="text-slate-dark/80 font-medium italic max-w-2xl mx-auto" data-id="element-171">
                La oferta vence en:
              </p>
            </div>

            <div className="flex justify-center" data-id="element-172">
              <div className="flex items-center gap-3 text-red-600 font-bold text-3xl bg-white px-8 py-3 rounded-2xl border-2 border-red-100 shadow-sm" data-id="element-173">
                <TimerIcon className="w-8 h-8 animate-pulse" data-id="element-174" />
                <span className="font-mono tracking-wider" data-id="element-175">{formatTime}</span>
              </div>
            </div>
          </div>

          <ShimmerButton onClick={onCtaClick} className="w-full text-xl md:text-2xl mb-6 py-6" data-id="element-176">
            SÍ — QUIERO UN PERRO TRANQUILO. ACCEDE AHORA POR $4.990 🐾
          </ShimmerButton>

          <div className="flex sm:flex-row gap-4 sm:gap-8 text-sm font-medium text-slate-dark/60 flex-row items-center justify-start" data-id="element-177">
            <div className="flex items-center gap-2" data-id="element-178">
              <ShieldCheckIcon className="w-5 h-5 text-slate-dark/40" data-id="element-179" />
              <span data-id="element-180">Garantía de 7 Días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-181">
              <UnlockIcon className="w-5 h-5 text-slate-dark/40" data-id="element-182" />
              <span data-id="element-183">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-184">
              <DownloadIcon className="w-5 h-5 text-slate-dark/40" data-id="element-185" />
              <span data-id="element-186">Acceso Inmediato</span>
            </div>
          </div>

          {/* Trust badge row */}
          <div className="flex flex-wrap gap-3 items-center justify-center" data-id="element-187">
            {/* Visa */}
            <div className="bg-white rounded-lg px-3 py-1.5 flex items-center justify-center shadow-[0_1px_4px_rgba(0,0,0,0.12)]" style={{
            maxHeight: 28
          }} data-id="element-188">
              <svg viewBox="0 0 750 471" className="h-5" fill="none" data-id="element-189">
                <path d="M278.198 334.228l33.36-195.763h53.358l-33.384 195.763H278.198z" fill="#1A1F71" data-id="element-190" />
                <path d="M524.307 142.687c-10.57-3.966-27.135-8.222-47.822-8.222-52.725 0-89.863 26.551-90.18 64.604-.634 28.141 26.485 43.845 46.754 53.185 20.77 9.536 27.77 15.636 27.77 24.17-.317 13.032-16.652 18.985-32.037 18.985-21.42 0-32.794-2.966-50.376-10.283l-6.902-3.113-7.519 43.845c12.507 5.467 35.638 10.199 59.673 10.454 56.062 0 92.425-26.187 92.862-66.884.317-22.27-14.016-39.215-44.8-53.185-18.652-9.072-30.078-15.099-30.078-24.267.317-8.258 9.703-16.834 30.712-16.834 17.567-.317 30.295 3.548 40.218 7.519l4.82 2.268 7.325-42.168z" fill="#1A1F71" data-id="element-191" />
                <path d="M661.615 138.465h-41.231c-12.773 0-22.332 3.478-27.94 16.218l-79.245 179.545h56.062l11.19-29.189h68.397l6.508 29.189h49.474l-43.215-195.763zm-65.927 126.408l28.09-73.14 4.503-12.844 7.83 12.844 16.33 73.14h-56.753z" fill="#1A1F71" data-id="element-192" />
                <path d="M232.903 138.465L180.663 271.96l-5.565-26.867c-9.703-31.107-39.93-64.921-73.744-81.822l47.822 170.64h56.379l83.826-195.446h-56.478z" fill="#1A1F71" data-id="element-193" />
                <path d="M131.92 138.465H46.459l-.634 3.966c66.878 16.152 111.16 55.128 129.495 101.932L156.72 155.318c-3.331-12.423-12.907-16.535-24.8-16.853z" fill="#F9A533" data-id="element-194" />
              </svg>
            </div>
            {/* Mastercard */}
            <div className="bg-white rounded-lg px-3 py-1.5 flex items-center justify-center shadow-[0_1px_4px_rgba(0,0,0,0.12)]" style={{
            maxHeight: 28
          }} data-id="element-195">
              <svg viewBox="0 0 152.407 108" className="h-5" fill="none" data-id="element-196">
                <circle cx="60.412" cy="54" r="48" fill="#EB001B" data-id="element-197" />
                <circle cx="91.995" cy="54" r="48" fill="#F79E1B" data-id="element-198" />
                <path d="M76.204 18.631a47.834 47.834 0 0 0-15.792 35.369A47.834 47.834 0 0 0 76.204 89.37a47.834 47.834 0 0 0 15.791-35.37 47.834 47.834 0 0 0-15.791-35.369z" fill="#FF5F00" data-id="element-199" />
              </svg>
            </div>
            {/* Mercado Pago */}
            <div className="bg-[#00B1EA] rounded-lg px-3 py-1.5 flex items-center justify-center shadow-[0_1px_4px_rgba(0,0,0,0.12)]" style={{
            maxHeight: 28
          }} data-id="element-200">
              <svg viewBox="0 0 80 20" className="h-3.5" fill="none" data-id="element-201">
                <text x="40" y="14.5" textAnchor="middle" fill="white" fontSize="10" fontWeight="700" fontFamily="Arial, Helvetica, sans-serif" letterSpacing="0.3" data-id="element-202">
                  Mercado Pago
                </text>
              </svg>
            </div>
            {/* Redcompra */}
            <div className="bg-[#E31E24] rounded-lg px-3 py-1.5 flex items-center justify-center shadow-[0_1px_4px_rgba(0,0,0,0.12)]" style={{
            maxHeight: 28
          }} data-id="element-203">
              <svg viewBox="0 0 80 20" className="h-3.5" fill="none" data-id="element-204">
                <text x="40" y="14.5" textAnchor="middle" fill="white" fontSize="11" fontWeight="700" fontFamily="Arial, Helvetica, sans-serif" letterSpacing="0.3" data-id="element-205">
                  Redcompra
                </text>
              </svg>
            </div>
            {/* Transferencia Bancaria */}
            <div className="bg-[#2D5F2D] rounded-lg px-3 py-1.5 flex items-center justify-center gap-1.5 shadow-[0_1px_4px_rgba(0,0,0,0.12)]" style={{
            maxHeight: 28
          }} data-id="element-206">
              <svg viewBox="0 0 20 20" className="h-3.5" fill="none" data-id="element-207">
                <rect x="3" y="4" width="14" height="2" rx="0.5" fill="white" data-id="element-208" />
                <rect x="5" y="7" width="2" height="7" fill="white" data-id="element-209" />
                <rect x="9" y="7" width="2" height="7" fill="white" data-id="element-210" />
                <rect x="13" y="7" width="2" height="7" fill="white" data-id="element-211" />
                <rect x="3" y="15" width="14" height="2" rx="0.5" fill="white" data-id="element-212" />
              </svg>
              <svg viewBox="0 0 80 20" className="h-3" fill="none" data-id="element-213">
                <text x="40" y="14" textAnchor="middle" fill="white" fontSize="10" fontWeight="700" fontFamily="Arial, Helvetica, sans-serif" letterSpacing="0.2" data-id="element-214">
                  Transferencia
                </text>
              </svg>
            </div>
          </div>
        </div>
      </FadeInUp>
    </section>;
}